import React from "react";
import { createRoot } from "react-dom/client";
//import './index.css';
//import 'bootstrap/dist/css/bootstrap.min.css'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import "./assets/styles/bootstrap.custom.css";
import "./assets/styles/index.css";
import "./assets/styles/foodApp.css";

import { SocketContextProvider } from "./SocketContext";

import LoginScreen from "./screens/LoginScreen";
import HomePageScreen from "./screens/HomeScreen";
import PrivateRoute from "./components/PrivateRoute";
import FoodsListScreen from "./screens/FoodListScreen";
import BookingSummaryScreen from "./screens/BookingSummaryScreen";
import OrderConfirmationScreen from "./screens/OrderConfirmationScreen";
import OrderDetailsScreen from "./screens/OrderDetailsScreen";
import TableOrderDetailsScreen from "./screens/TableOrderDetailsScreen";
import OrdersHistoryScreen from "./screens/OrdersHistoryScreen";
import NearByOutletsScreen from "./screens/NearByOutletsScreen";
import CartScreen from "./screens/CartScreen";
import CreateOrderScreen from "./screens/CreateOrderScreen";
import CashfreePayButtonScreen from "./screens/CashfreePayButtonScreen";
import FavouritesScreen from "./screens/FavouritesScreen";
import InformationScreen from "./screens/InformationScreen";
import PrivacyPolicyScreen from "./screens/PrivacyPolicy";
import RefundPolicyScreen from "./screens/RefundPolicyScreen";
import TermsAndConditions from "./screens/TermsAndConditions";
import ContactUsScreen from "./screens/ContactUsScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/:id" element={<HomePageScreen />} />
      <Route path="/foodsList/:id" element={<FoodsListScreen />} />
      <Route path="/bookingSummary" element={<BookingSummaryScreen />} />
      <Route path="/orderConfirmation" element={<OrderConfirmationScreen />} />
      <Route path="/myOrders/:orderId" element={<OrderDetailsScreen />} />
      <Route path="/tableOrderDetails" element={<TableOrderDetailsScreen />} />
      <Route path="/nearbyOutlets" element={<NearByOutletsScreen />} />
      <Route path="/createOrder" element={<CreateOrderScreen />} />
      <Route path="/cartItems" element={<CartScreen />} />
      <Route path="/orderHistory" element={<OrdersHistoryScreen />} />
      <Route path="/cashfreePayButton" element={<CashfreePayButtonScreen />} />
      <Route path="/favourites" element={<FavouritesScreen />} />
      <Route path="/information" element={<InformationScreen />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicyScreen />} />
      <Route path="/refundPolicy" element={<RefundPolicyScreen />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/contactUs" element={<ContactUsScreen />} />
      <Route path="" element={<PrivateRoute />}>
        {/* <Route path="/users/:id" element={<UserProfileScreen />}></Route> */}
      </Route>
    </Route>
  )
);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SocketContextProvider>
        <RouterProvider router={router} />
      </SocketContextProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
